<template>
  <a-modal
    title="服务区域"
    style="top: 20px;"
    :width="1200"
    v-model="visible3"
    :confirmLoading="confirmLoading"
    @cancel="handleClose1"
    :footer="false"
  >
    <a-form>
      <a-form-item style="display: flex;justify-content: flex-end;margin-right: 10%">
        <a-button type="primary" @click="addItem1">新增</a-button>
        <a-button  type="primary"  style="margin-left: 8px" @click="delectCoverage">删除</a-button>
      </a-form-item>
    </a-form>
    <a-table
      size="default"
      ref="table2"
      :columns="columns4"
      :dataSource="coverageData"
      :row-selection="{ selectedRowKeys: userAreaIds3, onChange: onSelectChange }"
      :pagination="false"
      :loading="loading"
      bordered
    >
        <span slot="action" slot-scope="text, record">
<!--          <a  @click="delectCoverage(record)">删除</a>-->
        </span>
    </a-table>
    <a-modal
      title="添加"
      style="top: 20px;"
      :width="800"
      v-model="visible4"
      :confirmLoading="confirmLoading"
      @cancel="handleClose2"
      @ok="handleSubmit02"
    >
      <a-form :form="form2">
        <a-form-item
          label="省份名称"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select v-decorator="['province', { rules:[{required: true, message: '请选择省份名称'}]}]" @change="haveProvince02">
            <a-select-option  v-for="type in data1" :key="type.provinceCode">{{type.provinceName}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="城市名称"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select v-decorator="['city', { rules:[{required: true, message: '请选择城市'}]}]" @change="haveProvince03">
            <a-select-option  v-for="type in cdata" :key="type.cityCode">{{type.cityName}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="区域名称"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >

          <a-checkbox :checked="checkAll" @change="onChange4()" >
            全选
          </a-checkbox>
          <br/>
          <a-checkbox-group v-decorator="['areaList', { rules:[{required: true, message: '区域名称'}]}]"  v-for="type in sdata"  @change="onChange">
            <a-checkbox :value="type.areaCode">
              {{type.areaName}}
            </a-checkbox>
          </a-checkbox-group>
          <a-alert v-if="warnShow" message="已选择全部区域，无法添加" type="warning" show-icon />
        </a-form-item>


        <!--<a-form-item-->
          <!--label="区域名称"-->
          <!--:label-col="{ span: 5 }"-->
          <!--:wrapper-col="{ span: 12 }"-->
        <!--&gt;-->
          <!--<a-select-->
            <!--mode="multiple"-->
            <!--v-decorator="['areaList', { rules:[{required: true, message: '区域名称'}]}]"-->
            <!---->
            <!--@change="handChange"-->
          <!--&gt;-->
            <!--<a-select-option  v-for="type in sdata" :key="type.areaCode">{{type.areaName}}</a-select-option>-->
          <!--</a-select>-->
        <!--</a-form-item>-->
      </a-form>
    </a-modal>
  </a-modal>

</template>

<script>
  import { getSelectAllProvince,
    getelectCityName,getelectAreaName,
  } from '@/api/master/MasterList'
  import {
    MemberServer,MemberServerInsert,MemberServerdelete,batchDelete2,
    selectArea
  } from '@/api/master/TeamManagement'
    export default {
        name: "memberService",
      data(){
          return{
            areaList:[],
            checkAll:false,
            warnShow:false,
            visible3:false,
            visible4:false,
            coverageData:[],
            columns4:[
              {
                title: '省',
                dataIndex: 'province',
                align:'center'
              },
              {
                title: '市',
                dataIndex: 'city',
                align:'center'
              },
              {
                title: '区',
                dataIndex: 'area',
                align:'center'
              },
              // {
              //   title: '操作',
              //   dataIndex: 'action',
              //   scopedSlots: { customRender: 'action'},
              // },
            ],
            data1:[],
            cdata:[],
            sdata:[],
            form2:this.$form.createForm(this),
            memberId:'',
            areaArray2:[],
            userAreaIds2:'',
            userAreaIds:[],
            selectedRowKeys:[],
            userAreaIds3:[],
          }
      },

      // computed: {
      //   rowSelection() {
      //     return {
      //       onChange: (selectedRowKeys, selectedRows) => {
      //         console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows.teamServerId);
      //         // this.userAreaIds = selectedRowKeys
      //         console.log(selectedRows.teamServerId)
      //         // for(let i=selectedRows.length;i>=selectedRows.length;i--){
      //         //   this.userAreaIds = selectedRows[i].teamServerId
      //         // }
      //         // this.userAreaIds = selectedRows.teamServerId
      //         this.userAreaIds2 = selectedRows
      //       },
      //       getCheckboxProps: record => ({
      //         props: {
      //           disabled: record.aduitStatus == '', // Column configuration not to be checked
      //           aduitStatus: record.aduitStatus,
      //         },
      //       }),
      //     };
      //
      //     // console.log("record", record)
      //   },
      // },


      methods:{

        onSelectChange(selectedRowKeys,selectedRows) {
          console.log('selectedRowKeys changed: ', selectedRowKeys);
          this.selectedRowKeys = selectedRowKeys;
          this.userAreaIds2 = selectedRows
          this.userAreaIds3 = selectedRowKeys
        },

        onChange4(){
          this.checkAll = !this.checkAll
          if(this.checkAll == true){
            this.$nextTick(()=>{
              this.form2.setFieldsValue({
                'areaList':  this.areaArray2
              })
            })
          }else {
            this.form2.setFieldsValue({
              'areaList':  []
            })
          }
        },
        onChange(checkedValues) {
          console.log('checked = ', checkedValues);
          if(checkedValues.length == this.areaArray2.length){
            this.checkAll = true
          }else{
            this.checkAll = false
          }
          this.$nextTick(()=>{
            this.form2.setFieldsValue({
              'areaList':  checkedValues
            })
          })
        },
        haveProvince02(value){
          // console.log(value)
          this.checkAll = false
          this.warnShow = false
          this.areaArray2 = []
          this.form2.setFieldsValue({'city':undefined,'areaList':[]})
          getelectCityName({provinceCode:value}).then(res=>{
            // console.log(res)
            this.cdata=res.rows
          })
        },
        haveProvince03(value){
          this.checkAll = false
          this.warnShow = false
          this.areaArray2 = []
          this.sdata = []
          this.form2.setFieldsValue({'areaList':[]})
          selectArea({
            cityCode:value,
            memberId:this.memberId
          }).then(res=>{
            console.log(res)
            this.sdata=res.rows
            for(let i=0;i<this.sdata.length;i++){
              this.areaArray2.push(this.sdata[i].areaCode)
            }
          })
        },
        handleClose1(){
          this.visible3 = false;
        },
        handleClose2(){
          this.visible4 = false;
        },
        //添加服务区域
        handleSubmit02(){
          let that=this
          this.form2.validateFields((err, values) => {
            if (!err) {
              values.teamId=that.memberId
              console.log(values)
              if(values.hasOwnProperty('areaList')){
                this.warnShow = false
                MemberServerInsert(values).then(res => {
                  console.log(res)
                  if (res.code === 0) {
                    this.$message.success('保存成功')
                    that.visible4 = false

                    MemberServer(that.memberId).then(res=>{
                      that.coverageData = res.rows
                    })
                  } else {
                    this.$message.error(res.msg)
                  }
                })
              }else{
                this.warnShow = true
              }
            }
          });
        },
        addItem1(){
          this.checkAll = false
          this.sdata = []
          this.form2.resetFields()
          getSelectAllProvince().then(res=>{
            // console.log(res)
            this.data1=res.rows
          })
          this.visible4=true
        },
        // 服务区删除
        delectCoverage(){

          for(let i=0;i<this.userAreaIds2.length;i++){
            this.userAreaIds.push(this.userAreaIds2[i].teamServerId)
          }
          let that=this
          this.$confirm({
            title: '删除',
            content: '您确定将本条数据删除吗？',
            okType: 'danger',
            onOk() {
              // let teamServerIds= that.qs.stringify({memberServerId})
              batchDelete2( that.userAreaIds).then(res => {
                if (res.code === 0) {
                  that.userAreaIds3 =[]
                  that.userAreaIds2 =[]
                  that.userAreaIds =[]
                  MemberServer(that.memberId).then(res=>{
                    console.log(res)
                    that.coverageData = res.rows
                  })
                  that.$message.success('删除成功')
                } else {
                  that.$message.error(res.msg)
                }
              })
            },
          })
        },
        add(reacd){
          this.memberId=reacd.memberId
          this.visible3 = true
          this.warnShow = false
          console.log(reacd)
          MemberServer(reacd.memberId).then(res=>{
            console.log(res)
            this.coverageData = res.rows
          })
        }
      },
    }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  padding: 4px 16px;}
</style>